import { render, staticRenderFns } from "./RoleManageEx.vue?vue&type=template&id=3053ef71&scoped=true"
import script from "./RoleManageEx.vue?vue&type=script&lang=js"
export * from "./RoleManageEx.vue?vue&type=script&lang=js"
import style0 from "./RoleManageEx.vue?vue&type=style&index=0&id=3053ef71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3053ef71",
  null
  
)

export default component.exports